import { render } from "./releaseManagement.vue?vue&type=template&id=2eb75d50&scoped=true"
import script from "./releaseManagement.vue?vue&type=script&lang=js"
export * from "./releaseManagement.vue?vue&type=script&lang=js"

import "./releaseManagement.vue?vue&type=style&index=0&id=2eb75d50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb75d50"]])

export default __exports__